"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCompleteGrowCycleMutation = exports.useStartGrowCycleMutation = exports.useAcknowledgeSeedsBatchMutation = exports.useAddSeedsBatchMutation = exports.useGetGrowCycleAcknowledgersQuery = exports.useGetGrowCycleAreasQuery = exports.useGetGrowCycleStartingMaterialQuery = exports.useUpdateGrowCycleMutation = exports.useCreateGrowCycleMutation = exports.useGetGrowCycleTimelineQuery = exports.useLazyGetGrowCyclesQuery = exports.useGetGrowCyclesQuery = exports.useGetGrowCycleQuery = exports.growCycleApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var api_url_1 = require("../../utils/api-url");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
var client_scoped_query_1 = require("../../utils/client-scoped-query");
exports.growCycleApi = (0, react_1.createApi)({
    reducerPath: "growCycleApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["grow-cycle"],
    endpoints: function (builder) { return ({
        getGrowCycle: builder.query({
            query: function (_a) {
                var id = _a.id, size = _a.size, pageNumber = _a.pageNumber, sortBy = _a.sortBy, sortDirection = _a.sortDirection;
                return (0, api_url_1.appendUrlParams)("/v1/grow-cycle/".concat(id), { size: size, pageNumber: pageNumber, sortBy: sortBy, sortDirection: sortDirection });
            },
            providesTags: ["grow-cycle"],
        }),
        getGrowCycles: builder.query({
            queryFn: (0, client_scoped_query_1.clientScopedQueryFn)("/v1/grow-cycle", function (arg) { return ({
                facility: arg.facilityId,
                stage: arg.stage,
            }); }),
            providesTags: ["grow-cycle"],
        }),
        getGrowCycleTimeline: builder.query({
            queryFn: (0, client_scoped_query_1.clientScopedQueryFn)("/v1/grow-cycle/timeline", function (arg) { return ({
                facility: arg.facilityId,
            }); }),
            providesTags: ["grow-cycle"],
        }),
        createGrowCycle: builder.mutation({
            query: function (body) { return ({
                url: "/v1/grow-cycle",
                method: "POST",
                body: body,
            }); },
            invalidatesTags: ["grow-cycle"],
        }),
        updateGrowCycle: builder.mutation({
            query: function (_a) {
                var id = _a.id, changes = __rest(_a, ["id"]);
                return ({ url: "/v1/grow-cycle/".concat(id), method: "PATCH", body: changes });
            },
            invalidatesTags: ["grow-cycle"],
        }),
        getGrowCycleStartingMaterial: builder.query({
            query: function (_a) {
                var growCycleId = _a.growCycleId, size = _a.size, pageNumber = _a.pageNumber, search = _a.search;
                return (0, api_url_1.appendUrlParams)("/v1/grow-cycle/".concat(growCycleId, "/starting-material"), { size: size, pageNumber: pageNumber, search: search });
            },
            providesTags: ["grow-cycle"],
        }),
        getGrowCycleAreas: builder.query({
            query: function (_a) {
                var growCycleId = _a.growCycleId, size = _a.size, pageNumber = _a.pageNumber, search = _a.search;
                return (0, api_url_1.appendUrlParams)("/v1/grow-cycle/".concat(growCycleId, "/areas"), { size: size, pageNumber: pageNumber, search: search });
            },
            providesTags: ["grow-cycle"],
        }),
        getGrowCycleAcknowledgers: builder.query({
            query: function (_a) {
                var growCycleId = _a.growCycleId, size = _a.size, pageNumber = _a.pageNumber, search = _a.search;
                return (0, api_url_1.appendUrlParams)("/v1/grow-cycle/".concat(growCycleId, "/acknowledgers"), { size: size, pageNumber: pageNumber, search: search });
            },
            providesTags: ["grow-cycle"],
        }),
        addSeedsBatch: builder.mutation({
            query: function (_a) {
                var growCycleId = _a.growCycleId, body = __rest(_a, ["growCycleId"]);
                return ({ url: "/v1/grow-cycle/".concat(growCycleId, "/seeds-batches"), method: "POST", body: body });
            },
            invalidatesTags: ["grow-cycle"],
        }),
        acknowledgeSeedsBatch: builder.mutation({
            query: function (_a) {
                var growCycleId = _a.growCycleId, batchId = _a.batchId;
                return ({ url: "/v1/grow-cycle/".concat(growCycleId, "/seeds-batches/").concat(batchId, "/acknowledge"), method: "PATCH" });
            },
            invalidatesTags: ["grow-cycle"],
        }),
        startGrowCycle: builder.mutation({
            query: function (id) { return ({ url: "/v1/grow-cycle/".concat(id, "/start"), method: "PATCH" }); },
            invalidatesTags: ["grow-cycle"],
        }),
        completeGrowCycle: builder.mutation({
            query: function (id) { return ({ url: "/v1/grow-cycle/".concat(id, "/complete"), method: "PATCH" }); },
            invalidatesTags: ["grow-cycle"],
        }),
    }); },
});
exports.useGetGrowCycleQuery = exports.growCycleApi.useGetGrowCycleQuery, exports.useGetGrowCyclesQuery = exports.growCycleApi.useGetGrowCyclesQuery, exports.useLazyGetGrowCyclesQuery = exports.growCycleApi.useLazyGetGrowCyclesQuery, exports.useGetGrowCycleTimelineQuery = exports.growCycleApi.useGetGrowCycleTimelineQuery, exports.useCreateGrowCycleMutation = exports.growCycleApi.useCreateGrowCycleMutation, exports.useUpdateGrowCycleMutation = exports.growCycleApi.useUpdateGrowCycleMutation, exports.useGetGrowCycleStartingMaterialQuery = exports.growCycleApi.useGetGrowCycleStartingMaterialQuery, exports.useGetGrowCycleAreasQuery = exports.growCycleApi.useGetGrowCycleAreasQuery, exports.useGetGrowCycleAcknowledgersQuery = exports.growCycleApi.useGetGrowCycleAcknowledgersQuery, exports.useAddSeedsBatchMutation = exports.growCycleApi.useAddSeedsBatchMutation, exports.useAcknowledgeSeedsBatchMutation = exports.growCycleApi.useAcknowledgeSeedsBatchMutation, exports.useStartGrowCycleMutation = exports.growCycleApi.useStartGrowCycleMutation, exports.useCompleteGrowCycleMutation = exports.growCycleApi.useCompleteGrowCycleMutation;
